import { defineComponent as _defineComponent } from 'vue'
import {ref, watch, onMounted} from "vue";
import IngredientCostRepository from "@/utils/API/IngredientCostRepository";
import { getErrorMessage } from "@/utils/Helpers";
import VModal from "@/components/vModal.vue";
import {useTranslations} from "@/hooks/useTranslations";
import VAddVendorModal from "@/components/costing/vAddVendorModal.vue";
import {Vendor} from "@/models/IngredientCost/Vendor";
import {useNotify} from "@/hooks/useNotify";


export default /*#__PURE__*/_defineComponent({
  __name: 'vImportBulkCostsModal',
  props: {
  show: { type: Boolean, required: true },
},
  emits: [
  "on-cancel",
  "on-imported"
],
  setup(__props, { emit }) {

const props = __props;





const notify = useNotify();
const isOpen = ref(props.show);
const vendorId = ref(null);
const vendorEmpty = ref(false);
const file = ref<File | null>(null);
const fileInput = ref<HTMLInputElement | null>(null);
const translations = useTranslations();
const vendors = ref<any[]>([]);
const showAddingVendorModal = ref(false);

watch(
  () => props.show,
  (newVal) => {
    isOpen.value = newVal;
    if (!newVal) resetForm();
  }
);

onMounted(() => {
  loadVendors();
});

function loadVendors() {
  if (!vendors.value.length) {
    IngredientCostRepository.listIngredientCostVendors()
      .then((res) => vendors.value = res.data.result)
      .catch((err) => notify.error(getErrorMessage(err, translations)));
  }
}

function storeFile(event: Event) {
  const input = event.target as HTMLInputElement;
  if (input.files && input.files.length > 0) {
    file.value = input.files[0];
  }
}

function openAddVendorModal() {
  showAddingVendorModal.value = true;
}

function downloadImport(){
  return `${process.env.VUE_APP_BASE_DOMAIN}/api/Processes/AdditionalCost/DownloadAdditionalCostImportTemplate`;
}

function handleClose() {
  resetForm();
  emit("on-cancel");
}

function resetForm() {
  vendorEmpty.value = false;
  file.value = null;
  if (fileInput.value) fileInput.value.value = "";
}

function handleVendorAdded(vendorList: Vendor[]) {
  vendors.value = vendorList;
}

async function submitImport() {
  if (!vendorId.value) {
    vendorEmpty.value = true;
    return;
  }

  const formData = new FormData();
  formData.append("file", file.value as File);

  try {
    // @ts-ignore
    const response = await IngredientCostRepository.uploadIngredientCosts(formData);

    const imported = response.data.result.map((x: any) => ({
      name: x.name,
      cost: x.cost,
      quantity: x.quantity,
      vendorId: vendorId.value,
      chosenMeasurementName: x.measurement,
    }));

    emit("on-imported", imported);
    handleClose();
  }
  catch (error) {
    // @ts-ignore
    this.$snotify.error(getErrorMessage(error, props.translations));
  }
}

return { __sfc: true,props, emit, notify, isOpen, vendorId, vendorEmpty, file, fileInput, translations, vendors, showAddingVendorModal, loadVendors, storeFile, openAddVendorModal, downloadImport, handleClose, resetForm, handleVendorAdded, submitImport, VModal, VAddVendorModal }
}

})